import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { I18nAdapterService } from 'src/app/infraestructure/adapters/i18n-adapter.service';
@Injectable({
  providedIn: 'root',
})
export class I18nDisplayerService implements TranslateLoader {
  constructor(private i18nAdapterService: I18nAdapterService) {}
  getTranslation(lang: string): Observable<any> {
    return this.i18nAdapterService.getI18n(lang);
  }
}

